import type { ReactNode } from 'react';

interface Props {
  title: string;
  accent: 'habit' | 'task' | 'ach';
  icon: string;
  count: number;
  onAdd: () => void;
  children: ReactNode;
}

const HEADER = {
  habit: 'text-habit-400 border-habit-500/40',
  task: 'text-task-400 border-task-500/40',
  ach: 'text-ach-400 border-ach-500/40',
} as const;

const ADD_BG = {
  habit: 'hover:bg-habit-bg hover:border-habit-500',
  task: 'hover:bg-task-bg hover:border-task-500',
  ach: 'hover:bg-ach-bg hover:border-ach-500',
} as const;

export function KanbanColumn({ title, accent, icon, count, onAdd, children }: Props) {
  return (
    <section className="flex min-h-[400px] flex-col rounded-xl border border-border-soft bg-bg-raised/30 p-3">
      <header className={`mb-3 flex items-center justify-between border-b pb-2 ${HEADER[accent]}`}>
        <div className="flex items-center gap-2">
          <span>{icon}</span>
          <h2 className="font-semibold">{title}</h2>
        </div>
        <span className="font-pixel text-[10px] text-neutral-500">{count}</span>
      </header>
      <ul className="flex-1 space-y-2">{children}</ul>
      <button
        onClick={onAdd}
        className={`mt-3 rounded-lg border border-dashed border-border-soft py-2 text-xs text-neutral-400 transition ${ADD_BG[accent]}`}
      >
        + Yeni ekle
      </button>
    </section>
  );
}
